import type { TFilters } from '../types/filters';

export const enum FILTERS_NAME {
  OrganizationType = 'organizationType',
  Service = 'service',
  Location = 'location',
  CustomerType = 'customerType',
  RatingType = 'ratingType',
}

export enum CUSTOMER_TYPES {
  Individuals = 'individuals',
  Businesses = 'businesses',
  Both = 'both', // тип, который может быть и у юриков и у физиков
  All = 'all',
}

export enum RATING_TYPES {
  Organizations = 'organizations',
  Products = 'products',
}

export const ROUTE_TO_CUSTOMER_TYPE = {
  'dlya-predprinimatelej': CUSTOMER_TYPES.Businesses,
  'dlya-chastnyh-lic': CUSTOMER_TYPES.Individuals,
};

export const CUSTOMER_TYPE_TO_ROUTE = {
  [CUSTOMER_TYPES.Businesses]: 'dlya-predprinimatelej',
  [CUSTOMER_TYPES.Individuals]: 'dlya-chastnyh-lic',
  [CUSTOMER_TYPES.All]: null,
};

export enum REVIEWS_CATEGORY {
  ALL = 'all',
  MORE_THAN_10 = 'Min10',
  MORE_THAN_50 = 'Min50',
  MORE_THAN_100 = 'Min100',
  MORE_THAN_300 = 'Min300',
  MORE_THAN_500 = 'Min500',
}

export const DEFAULT_FILTERS: TFilters = {
  [FILTERS_NAME.OrganizationType]: null,
  [FILTERS_NAME.Service]: null,
  [FILTERS_NAME.Location]: null,
  [FILTERS_NAME.CustomerType]: CUSTOMER_TYPES.All,
  [FILTERS_NAME.RatingType]: RATING_TYPES.Organizations,
};

export const FilterNameToAnalyticAction = {
  [FILTERS_NAME.Service]: 'Вид продукта',
  [FILTERS_NAME.Location]: 'Город',
};

export const CUSTOMER_TYPE_TO_BOOLEAN = {
  [CUSTOMER_TYPES.Individuals]: false,
  [CUSTOMER_TYPES.Businesses]: true,
  [CUSTOMER_TYPES.All]: null,
};

export const CUSTOMER_TYPE_TO_LABEL = {
  [CUSTOMER_TYPES.Both]: 'Общие',
  [CUSTOMER_TYPES.Individuals]: 'Физлицам',
  [CUSTOMER_TYPES.Businesses]: 'Юрлицам',
  [CUSTOMER_TYPES.All]: 'Все',
};

export const RATING_TYPE_TO_LABEL = {
  [RATING_TYPES.Organizations]: 'По организациям',
  [RATING_TYPES.Products]: 'Продукты',
};

export const REVIEWS_COUNT_LABELS = {
  [REVIEWS_CATEGORY.ALL]: 'Любое количество отзывов',
  [REVIEWS_CATEGORY.MORE_THAN_10]: 'Более 10 отзывов',
  [REVIEWS_CATEGORY.MORE_THAN_50]: 'Более 50 отзывов',
  [REVIEWS_CATEGORY.MORE_THAN_100]: 'Более 100 отзывов',
  [REVIEWS_CATEGORY.MORE_THAN_300]: 'Более 300 отзывов',
  [REVIEWS_CATEGORY.MORE_THAN_500]: 'Более 500 отзывов',
};

export const OLD_PRODUCT_CATEGORY_TO_CUSTOMER_TYPE: {
  [key: string]: CUSTOMER_TYPES;
} = {
  natural: CUSTOMER_TYPES.Individuals,
  legal: CUSTOMER_TYPES.Businesses,
};
